import React from 'react'
import { Event } from 'app/types/authorization'
import { ArenaSection, ArenaSectionSeatTypes } from 'app/types/arena'
import LivedayLoader from '../components/old/animations/LivedayLoader'
import { TicketPicker } from './old/TicketsPicker'

interface ArenaSectionProps {
  event: Event
  section: ArenaSection
  isRegister?: boolean
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>
  setShowSuccessMessage: React.Dispatch<React.SetStateAction<string>>
  setShowFailureMessage: React.Dispatch<React.SetStateAction<string>>
  refetchCart: () => void
  ticketsInCart: string[] | undefined
  tickets: ArenaSectionSeatTypes[][]
  fetchTickets: () => Promise<void>
  sectionLoading: boolean
}

export function ArenaSectionComponent({
  event,
  tickets,
  setShowSuccessMessage,
  setShowFailureMessage,
  refetchCart,
  ticketsInCart,
  fetchTickets,
  sectionLoading,
}: ArenaSectionProps) {
  return (
    <div className="min-h-screen bg-gray-50">
      {sectionLoading && tickets.length === 0 ? (
        <LivedayLoader />
      ) : (
        <TicketPicker
          eventId={event.sk}
          tickets={tickets}
          ticketsInCart={ticketsInCart}
          refetch={() => {
            fetchTickets()
            refetchCart()
          }}
          setShowSuccessMessage={setShowSuccessMessage}
          setShowFailureMessage={setShowFailureMessage}
        />
      )}
    </div>
  )
}
